var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStandard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 41,
    viewBox: "0 0 33 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 1.75H31.5V39.25H6.1875C4.9443 39.25 3.75201 38.7561 2.87294 37.8771C1.99386 36.998 1.5 35.8057 1.5 34.5625V6.4375C1.5 5.1943 1.99386 4.00201 2.87294 3.12294C3.75201 2.24386 4.9443 1.75 6.1875 1.75V1.75Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStandard1);
export default __webpack_public_path__ + "static/media/IconStandard1.3ee71e8db110c8b9de374e137aac18f3.svg";
export { ForwardRef as ReactComponent };